import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CalanderCarosel.css";
import Navbar from "./Navbar";
import Footer from "./Footer";

// API Base URL
const API_BASE_URL = 'https://royaleheritagefiesta.com/royaleheritagefiesta/api';

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function Event_calander() {

  const [monthIndex, setMonthIndex] = useState(new Date().getMonth());
  const [events, setEvents] = useState([]);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // ---------------- FETCH EVENTS FROM PHP API ----------------
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/events.php?all`);
        const data = await response.json();
        
        // Transform data to match expected format
        const formattedEvents = data.map(event => ({
          eid: event.eventId,
          eventName: event.eventName,
          eventDate: event.eventDate,
          place: event.place,
          highlights: event.highlights,
          spansour: event.spansour,
          budget: event.budget,
          stallPrice: event.stallPrice,
          ticketPrice: event.ticketPrice,
          hasSeating: event.hasSeating,
          seatingType: event.seatingType,
          seatRows: event.seatRows,
          seatColumns: event.seatColumns,
          totalSeats: event.totalSeats,
          standingCapacity: event.standingCapacity,
          showEntrance: event.showEntrance,
          showExit: event.showExit,
          showStage: event.showStage,
          showParking: event.showParking,
          parkingZones: event.parkingZones,
          hasVIPParking: event.hasVIPParking,
          showFoodCourt: event.showFoodCourt,
          showRestrooms: event.showRestrooms,
          showFirstAid: event.showFirstAid,
          isCustomLayout: event.isCustomLayout,
          stallPattern: event.stallPattern
        }));
        
        setEvents(formattedEvents);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    
    fetchEvents();
  }, []);

  // Scroll listener for floating buttons
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
      setShowFloatingButtons(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/919966252374?text=Hi%20Royal%20Heritage%20Festia%20team,%20I%27m%20interested%20in%20your%20events.', '_blank');
  };

  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
  const startDay = new Date(year, monthIndex, 1).getDay();

  // Function to handle navigation to event card
  const handleDateClick = (event) => {
    navigate("/eventCard", {
      state: { eventId: event.eid }
    });
  };

  // Function to check if event is completed
  const isEventCompleted = (eventDate) => {
    const eventDateTime = new Date(eventDate);
    eventDateTime.setHours(0, 0, 0, 0);
    return eventDateTime < today;
  };

  // Function to get highlights
  const getHighlights = (highlights) => {
    if (!highlights) return [];
    
    const lines = highlights.split('\n').filter(line => line.trim() !== '');
    return lines.slice(0, 3);
  };

  // Handle popup on mobile click
  useEffect(() => {
    const handleCalendarDayClick = (e) => {
      const calendarDay = e.target.closest('.calendar-day');
      if (calendarDay && window.innerWidth <= 768) {
        // Remove active class from all days
        document.querySelectorAll('.calendar-day').forEach(day => {
          day.classList.remove('active');
        });
        // Add active class to clicked day
        calendarDay.classList.add('active');
        
        // Close popup when clicking outside
        const handleOutsideClick = (outsideEvent) => {
          if (!calendarDay.contains(outsideEvent.target)) {
            calendarDay.classList.remove('active');
            document.removeEventListener('click', handleOutsideClick);
          }
        };
        
        setTimeout(() => {
          document.addEventListener('click', handleOutsideClick);
        }, 100);
      }
    };
    
    document.addEventListener('click', handleCalendarDayClick);
    
    return () => {
      document.removeEventListener('click', handleCalendarDayClick);
    };
  }, []);

  return (
    <>
      <Navbar />

      <style>{`
        /* ===== ROYAL HERITAGE THEME ===== */
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body { 
          background: #111; 
          font-family: 'Montserrat', sans-serif; 
          margin: 0; 
          color: #333; 
        }

        /* MAIN CONTAINER - With black borders */
        .event-calendar-wrapper {
          background: #f5f5f5;
          margin: 0 auto;
          width: 98%;
          max-width: 1400px;
          border-left: 11px solid #000;
          border-right: 11px solid #000;
          border-radius: 0;
          padding: 1rem;
          min-height: calc(100vh - 200px);
        }

        /* Calendar Container */
        .calendar-container {
          max-width: 1200px;
          margin: 0 auto;
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          border: 1px solid #eee;
        }

        /* Calendar Header */
        .calendar-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 1.5rem;
          background: #fff;
          border-bottom: 2px solid #b8860b;
        }

        .calendar-header h2 {
          font-family: 'Cinzel', serif;
          font-size: 1.4rem;
          font-weight: 700;
          color: #000;
          margin: 0;
        }

        .nav-btn {
          background: #b8860b;
          color: white;
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          font-size: 1.1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .nav-btn:hover {
          background: #9b6e09;
          transform: scale(1.05);
        }

        /* Weekdays Grid */
        .calendar-weekdays {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          background: #fafaf5;
          border-bottom: 1px solid #eee;
        }

        .calendar-weekdays div {
          padding: 0.8rem;
          text-align: center;
          font-weight: 600;
          color: #b8860b;
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        /* Calendar Grid */
        .calendar-grid {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          background: #fff;
        }

        .calendar-empty {
          background: #fafafa;
          min-height: 110px;
          border-right: 1px solid #f0f0f0;
          border-bottom: 1px solid #f0f0f0;
        }

        .calendar-day {
          min-height: 110px;
          padding: 0.6rem;
          border-right: 1px solid #f0f0f0;
          border-bottom: 1px solid #f0f0f0;
          position: relative;
          transition: all 0.2s ease;
          background: #fff;
          vertical-align: top;
        }

        .calendar-day:hover {
          background: #fef9f0;
        }

        .calendar-day.has-event {
          background: #fffaf5;
          cursor: pointer;
        }

        .calendar-day.has-event:hover {
          background: #fff5e8;
        }

        /* Completed event styling */
        .calendar-day.completed-event {
          background: #f9f9f9;
          opacity: 0.8;
          cursor: default;
        }

        .calendar-day.completed-event:hover {
          background: #f9f9f9;
        }

        .day-number {
          display: inline-block;
          font-weight: 600;
          font-size: 0.95rem;
          color: #333;
          margin-bottom: 0.4rem;
          background: #fff;
          padding: 0.2rem 0.4rem;
          border-radius: 6px;
        }

        .completed-event .day-number {
          color: #999;
        }

        .event-name {
          display: block;
          font-size: 0.7rem;
          color: #b8860b;
          font-weight: 600;
          line-height: 1.3;
          margin-top: 0.2rem;
          word-break: break-word;
          background: rgba(184, 134, 11, 0.1);
          padding: 0.25rem 0.4rem;
          border-radius: 4px;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .completed-event .event-name {
          color: #999;
          background: rgba(153, 153, 153, 0.1);
          text-decoration: line-through;
        }

        /* Event Popup */
        .event-popup {
          position: absolute;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          background: #fff;
          min-width: 280px;
          max-width: 320px;
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
          opacity: 0;
          visibility: hidden;
          transition: all 0.25s ease;
          z-index: 1000;
          pointer-events: none;
          margin-bottom: 8px;
          border: 1px solid #e0e0e0;
        }

        .calendar-day.has-event:hover .event-popup {
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
          bottom: 100%;
        }

        /* Position popup on left side for days on right edge */
        .calendar-day:nth-child(7n) .event-popup,
        .calendar-day:nth-child(7n-1) .event-popup {
          left: auto;
          right: 0;
          transform: translateX(0);
        }

        /* Position popup on right side for days on left edge */
        .calendar-day:nth-child(7n-6) .event-popup,
        .calendar-day:nth-child(7n-5) .event-popup {
          left: 0;
          transform: translateX(0);
        }

        .popup-content {
          padding: 1rem;
        }

        .popup-content h4 {
          font-family: 'Cinzel', serif;
          font-size: 1rem;
          font-weight: 700;
          color: #b8860b;
          margin-bottom: 0.5rem;
          border-bottom: 1px solid #f0f0f0;
          padding-bottom: 0.4rem;
        }

        .popup-location {
          font-size: 0.75rem;
          color: #666;
          margin-bottom: 0.8rem;
          display: flex;
          align-items: center;
          gap: 0.3rem;
        }

        .popup-date {
          font-size: 0.7rem;
          color: #888;
          margin-bottom: 0.8rem;
          display: flex;
          align-items: center;
          gap: 0.3rem;
        }

        .popup-highlights {
          margin-bottom: 1rem;
          padding-top: 0.5rem;
          border-top: 1px solid #f0f0f0;
        }

        .popup-highlights-title {
          font-size: 0.7rem;
          font-weight: 600;
          color: #b8860b;
          margin-bottom: 0.4rem;
          display: flex;
          align-items: center;
          gap: 0.3rem;
        }

        .popup-highlights-text {
          display: flex;
          flex-direction: column;
          gap: 0.3rem;
        }

        .popup-highlights-text span {
          font-size: 0.7rem;
          color: #666;
          line-height: 1.4;
        }

        .popup-btn {
          background: #b8860b;
          color: white;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.7rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 100%;
        }

        .popup-btn:hover {
          background: #9b6e09;
          transform: translateY(-2px);
        }

        .popup-btn-disabled {
          background: #ccc;
          color: #666;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.7rem;
          font-weight: 600;
          cursor: not-allowed;
          width: 100%;
        }

        /* Completed event popup */
        .completed-popup {
          position: absolute;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          background: #f5f5f5;
          min-width: 260px;
          max-width: 300px;
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          opacity: 0;
          visibility: hidden;
          transition: all 0.25s ease;
          z-index: 1000;
          pointer-events: none;
          margin-bottom: 8px;
          border: 1px solid #ddd;
        }

        .calendar-day.completed-event:hover .completed-popup {
          opacity: 1;
          visibility: visible;
        }

        .completed-popup .popup-content h4 {
          color: #999;
        }

        .completed-badge {
          display: inline-block;
          background: #ddd;
          color: #666;
          padding: 0.2rem 0.5rem;
          border-radius: 4px;
          font-size: 0.65rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        /* Floating Buttons */
        .floating-buttons {
          position: fixed;
          bottom: 20px;
          right: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px);
          transition: 0.3s;
        }

        .floating-buttons.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .floating-btn {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          border: none;
          cursor: pointer;
          transition: 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          color: #fff;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        }

        .floating-btn.whatsapp {
          background: #25d366;
        }

        .floating-btn.top {
          background: #b8860b;
        }

        .floating-btn:hover {
          transform: scale(1.1);
        }

        .back-to-top {
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 45px;
          height: 45px;
          background: #b8860b;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          opacity: 0;
          visibility: hidden;
          transition: 0.2s;
          z-index: 99;
          border: none;
        }

        .back-to-top.show {
          opacity: 1;
          visibility: visible;
        }

        .back-to-top:hover {
          background: #9b6e09;
          transform: translateY(-3px);
        }

        /* Responsive */
        @media (max-width: 992px) {
          .event-calendar-wrapper {
            width: 96%;
            padding: 0.8rem;
          }
          
          .calendar-header h2 {
            font-size: 1.2rem;
          }
          
          .calendar-header {
            padding: 0.8rem 1rem;
          }
          
          .calendar-weekdays div {
            padding: 0.6rem 0.3rem;
            font-size: 0.75rem;
          }
          
          .calendar-day {
            min-height: 95px;
            padding: 0.4rem;
          }
          
          .day-number {
            font-size: 0.85rem;
          }
          
          .event-name {
            font-size: 0.65rem;
          }
        }

        @media (max-width: 768px) {
          .event-calendar-wrapper {
            padding: 0.5rem;
          }
          
          .calendar-header h2 {
            font-size: 1rem;
          }
          
          .nav-btn {
            width: 30px;
            height: 30px;
            font-size: 0.9rem;
          }
          
          .calendar-weekdays div {
            padding: 0.5rem 0.2rem;
            font-size: 0.7rem;
          }
          
          .calendar-day {
            min-height: 80px;
            padding: 0.3rem;
          }
          
          .day-number {
            font-size: 0.75rem;
            margin-bottom: 0.2rem;
          }
          
          .event-name {
            font-size: 0.6rem;
            padding: 0.2rem 0.3rem;
            -webkit-line-clamp: 1;
          }
          
          .event-popup, .completed-popup {
            min-width: 220px;
            max-width: 260px;
          }
          
          .popup-content {
            padding: 0.8rem;
          }
          
          .popup-content h4 {
            font-size: 0.85rem;
          }
        }

        @media (max-width: 576px) {
          .calendar-weekdays div {
            font-size: 0.6rem;
            padding: 0.4rem 0.1rem;
          }
          
          .calendar-day {
            min-height: 65px;
            padding: 0.2rem;
          }
          
          .day-number {
            font-size: 0.7rem;
          }
          
          .event-name {
            font-size: 0.55rem;
            display: none;
          }
          
          .calendar-day.has-event .day-number {
            color: #b8860b;
            font-weight: 700;
            position: relative;
          }
          
          .calendar-day.has-event .day-number::after {
            content: "●";
            position: absolute;
            top: -2px;
            right: -8px;
            color: #b8860b;
            font-size: 0.6rem;
          }
          
          .calendar-day.completed-event .day-number::after {
            color: #999;
          }
          
          .event-popup, .completed-popup {
            min-width: 200px;
            max-width: 220px;
          }
        }
      `}</style>

      <div className="event-calendar-wrapper">
        <div className="calendar-container">
          <div className="calendar-header">
            <button onClick={() => setMonthIndex(m => (m === 0 ? 11 : m - 1))} className="nav-btn">←</button>
            <h2>{MONTHS[monthIndex]} {year}</h2>
            <button onClick={() => setMonthIndex(m => (m === 11 ? 0 : m + 1))} className="nav-btn">→</button>
          </div>

          <div className="calendar-weekdays">
            {DAYS.map(day => <div key={day}>{day}</div>)}
          </div>

          <div className="calendar-grid">
            {Array(startDay).fill("").map((_, i) => (
              <div key={i} className="calendar-empty"></div>
            ))}

            {Array.from({ length: daysInMonth }, (_, i) => {
              const day = i + 1;
              const fullDate = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

              const eventForDay = events.find(
                event => event.eventDate === fullDate
              );

              // Check if event is completed
              const completed = eventForDay ? isEventCompleted(eventForDay.eventDate) : false;
              
              // Get highlights
              const highlights = eventForDay ? getHighlights(eventForDay.highlights) : [];

              // Format date for display
              const formattedDate = eventForDay ? new Date(eventForDay.eventDate).toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              }) : '';

              return (
                <div 
                  key={i} 
                  className={`calendar-day ${eventForDay ? 'has-event' : ''} ${completed ? 'completed-event' : ''}`}
                  onClick={() => eventForDay && !completed && handleDateClick(eventForDay)}
                  style={{ cursor: (eventForDay && !completed) ? 'pointer' : 'default' }}
                >
                  <span className="day-number">{day}</span>

                  {eventForDay && !completed && (
                    <>
                      <span className="event-name">
                        {eventForDay.eventName}
                      </span>
                      
                      {/* Popup for upcoming events */}
                      <div className="event-popup">
                        <div className="popup-content">
                          <h4>{eventForDay.eventName}</h4>
                          
                          <p className="popup-date">
                            <span>📅</span> {formattedDate}
                          </p>
                          
                          <p className="popup-location">
                            <span>📍</span> 
                            {eventForDay.place || "Venue TBA"}
                          </p>

                          {highlights && highlights.length > 0 && (
                            <div className="popup-highlights">
                              <div className="popup-highlights-title">
                                <span>✨</span> Highlights
                              </div>
                              <div className="popup-highlights-text">
                                {highlights.map((line, idx) => (
                                  <span key={idx}>• {line.replace(/^[•\-*]\s*/, '').trim()}</span>
                                ))}
                              </div>
                            </div>
                          )}

                          <button 
                            className="popup-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDateClick(eventForDay);
                            }}
                          >
                            View Details →
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {eventForDay && completed && (
                    <>
                      <span className="event-name">
                        {eventForDay.eventName}
                      </span>
                      
                      {/* Popup for completed events */}
                      <div className="completed-popup">
                        <div className="popup-content">
                          <div className="completed-badge">Event Completed</div>
                          <h4 style={{ color: '#999' }}>{eventForDay.eventName}</h4>
                          
                          <p className="popup-date">
                            <span>📅</span> {formattedDate}
                          </p>
                          
                          <p className="popup-location">
                            <span>📍</span> 
                            {eventForDay.place || "Venue TBA"}
                          </p>

                          {highlights && highlights.length > 0 && (
                            <div className="popup-highlights">
                              <div className="popup-highlights-title">
                                <span>✨</span> Highlights
                              </div>
                              <div className="popup-highlights-text">
                                {highlights.map((line, idx) => (
                                  <span key={idx}>• {line.replace(/^[•\-*]\s*/, '').trim()}</span>
                                ))}
                              </div>
                            </div>
                          )}

                          <div className="popup-btn-disabled">
                            Event Passed
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <Footer />

      {/* Floating Buttons */}
      <div className={`floating-buttons ${showFloatingButtons ? 'show' : ''}`}>
        <button className="floating-btn whatsapp" onClick={handleWhatsAppClick}>
          <i className="bi bi-whatsapp"></i>
        </button>
        <button className="floating-btn top" onClick={handleBackToTop}>
          <i className="bi bi-arrow-up"></i>
        </button>
      </div>

      {/* Back to Top Button */}
      <div className={`back-to-top ${showBackToTop ? 'show' : ''}`} onClick={handleBackToTop}>
        <i className="bi bi-arrow-up"></i>
      </div>
    </>
  );
}